import {fieldValue} from "../common/NamaCommon";
import {PasswordWidget} from "../widgets/PasswordWidget";

export function passwordTemplate(fieldId, trimmedFieldId) {

    return (dataItem) => {
        let value = fieldValue(dataItem, trimmedFieldId);
        if (!value)
            return "";
        return "**********";
    }
}

export function passwordColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        let widget = new PasswordWidget({owner: grid, fieldMetadata, cellOptions: options});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}